import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../config";
import { cacheDataForInSeconds } from "../constants";
import baseQueryWithCorrelationId from "../services/baseQueryWithCorrelationId";

let reactBaseurl = "";
const { user } = (state) => state.auth;
if (user !== null) {
    if (user?.isUserInternal === true) {
        reactBaseurl = reactBaseurl;
    } else if (user?.isUserInternal === false) {
        reactBaseurl = config.REACT_APP_EXTERNAL_PREFERENCE_API_URL;
    }
}

const userPreferenceApiSlice = createApi({
    reducerPath: "UserPreferences",
    keepUnusedDataFor: cacheDataForInSeconds ?? 300,
    refetchOnMountOrArgChange: cacheDataForInSeconds ?? 300,
    baseQuery: baseQueryWithCorrelationId(config.REACT_APP_API_URL),
    endpoints: (builder) => ({
        getUserPreferenceData: builder.query({
            query: ({ userId }) => ({
                url: `/user-data/${process.env.REACT_APP_API_VERSION}/${userId}${config.REACT_APP_ENV_NAME}`,
                method: "GET",
                params: "",
            }),
        }),
        updateUserData: builder.mutation({
            query: ({ userId, dataToUpdate }) => ({
                url: `/user-data/${process.env.REACT_APP_API_VERSION}/${userId}${config.REACT_APP_ENV_NAME}`,
                method: "PATCH",
                body: JSON.stringify(dataToUpdate),
            }),
        }),
    }),
});

export const {
    useUpdateUserDataMutation,
    useGetUserPreferenceDataQuery,
    useLazyGetUserPreferenceDataQuery,
} = userPreferenceApiSlice;

export default userPreferenceApiSlice;
